import React from "react";
import { BrowserRouter } from "react-router-dom";

import Nav from "components/nav";
import { ThemeProvider } from "styled-components";

import "./App.css";

import Banner from "./components/banner";
import Noticia from "./components/noticia";
import Routes from "./router";
import GlobalStyle from "./styles/global";
import light from "./styles/themes/light";

function App() {
  return (
    <ThemeProvider theme={light}>
      <GlobalStyle />
      <BrowserRouter>
        <Nav />
        <Noticia />
        <div id="container_banner">
          <Banner />
        </div>
        <Routes />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
